import React from 'react';
import Plot from 'react-plotly.js';
import './FullscreenModal.css';

interface FullscreenModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: {
        type: 'plotly' | 'image' | 'iframe';
        data?: any;
        layout?: any;
        src?: string;
        srcDoc?: string;
    };
}

const FullscreenModal: React.FC<FullscreenModalProps> = ({ isOpen, onClose, content }) => {
    if (!isOpen) return null;

    return (
        <div className="fullscreen-modal" onClick={onClose}>
            <button className="fullscreen-close" onClick={onClose}>×</button>
            <div className="fullscreen-modal-content" onClick={e => e.stopPropagation()}>
                <div className="fullscreen-content">
                    {content.type === 'plotly' && content.data && (
                        <Plot
                            data={content.data}
                            layout={{
                                ...content.layout,
                                width: undefined,
                                height: undefined,
                                autosize: true,
                                responsive: true,
                                margin: { l: 60, r: 60, t: 60, b: 60 }
                            }}
                            config={{
                                responsive: true,
                                displaylogo: false,
                                modeBarButtonsToRemove: [
                                    'sendDataToCloud',
                                    'toggleSpikelines'
                                ]
                            }}
                            style={{
                                width: '100%',
                                height: '100%'
                            }}
                            useResizeHandler={true}
                        />
                    )}
                    {content.type === 'image' && content.src && (
                        <img src={content.src} alt="Fullscreen Chart" />
                    )}
                    {content.type === 'iframe' && content.srcDoc && (
                        <iframe
                            srcDoc={content.srcDoc}
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none'
                            }}
                            title="Fullscreen Chart"
                            sandbox="allow-scripts allow-same-origin"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default FullscreenModal;